export default __webpack_public_path__ + "static/media/coffeecups.ff241281.png";